import React from "react";
import InputField from "../InputField";
import Dropdown from "../Dropdown";

/**
 * Renders the customer's own SCO questions (PBI #320) — free text, checkbox or
 * dropdown, configured per customer by Diflex. Answers are keyed by the question's
 * public id; the API resolves the labels server-side when building the case mail.
 *
 * They sit in their own "Customer specific fields" section (#366), so they read as this
 * customer's additions rather than part of the standard form; a customer without questions
 * gets no section at all.
 *
 * A dropdown whose options could not be served falls back to free text, so a
 * configuration problem never makes a question unanswerable.
 */
const CustomQuestionFields = ({ questions, answers, onAnswerChange }) => {
  if (!questions || questions.length === 0) return null;

  return (
    <section className="flex flex-col gap-4 w-full">
      <h3 className="font-bold">Customer specific fields</h3>
      {questions.map((question) => {
        const id = question.scoCustomQuestionPublicId;
        const type = (question.questionType || "").toLowerCase();
        const options = question.options || [];

        if (type === "checkbox") {
          const checked = answers[id] === true;

          return (
            <label
              key={id}
              className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
            >
              <input
                type="checkbox"
                className="custom-checkbox-input hidden"
                checked={checked}
                onChange={() => onAnswerChange(id, !checked)}
              />
              <div className="custom-checkbox mr-2">
                <svg
                  className="custom-checkbox-icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              {question.label}
            </label>
          );
        }

        if (type === "dropdown" && options.length > 0) {
          return (
            <Dropdown
              key={id}
              label={question.label}
              value={answers[id] || ""}
              options={options}
              onSelect={(option) => onAnswerChange(id, option)}
              placeholder="Choose an option"
              searchable={options.length > 10}
            />
          );
        }

        return (
          <InputField
            key={id}
            label={question.label}
            value={answers[id] || ""}
            onChange={(e) => onAnswerChange(id, e.target.value)}
            placeholder="Enter answer"
            type="text"
          />
        );
      })}
    </section>
  );
};

export default CustomQuestionFields;
